<template>
  <el-dialog
    :visible.sync="dialogVisibleProblem"
    :before-close="cancel"
    width="1100px">
    <div class="scroll" style="font-size: 18px;letter-spacing: 1px;margin:20px 0;line-height: 45px;height: 700px;overflow-y: auto">
      <p style="text-align: center; margin-bottom: 50px">
        <span style="font-size: 24px;"><strong>常见问题及解答</strong></span>
      </p>
      <p style="text-indent: 2em;">
        <strong>一、项目一般要安排在什么时间实施呢？</strong>
      </p>
      <p style="text-indent: 2em; ">
        项目实施时间建议初步设置在2026年6月-10月，根据项目实际内容在该时间段内进行具体进度安排，11月-12月为项目结项、绩效评价、宣传材料制作阶段。
      </p>
      <p style="text-indent: 2em;">
        <strong>二、项目必须要有自筹资金吗？</strong>
      </p>
      <p style="text-indent: 2em; ">
        无要求，申报单位根据实际情况填写自筹资金金额即可，如没有自筹资金，则填0元。
      </p>
      <p style="text-indent: 2em;">
        <strong>三、现在需要制定实施方案吗？</strong>
      </p>
      <p style="text-indent: 2em; ">
        申报期间按要求提交申报书等材料即可，如通过评审、确定立项支持后，需要根据评审专家意见、拟支持金额及预期实施时间等优化申报项目内容，制定具体实施方案，并签订合同。
      </p>
      <p style="text-indent: 2em;">
        <strong>四、实施地盖章是必须的吗？</strong>
      </p>
      <p style="text-indent: 2em; ">
        为确保拟支持项目可以顺利实施，避免实施地无相关服务需求，申报单位一般应提前征得社区（村）、街道（乡镇）或市、区委办局等实施地单位同意并盖章。
      </p>
      <p style="text-indent: 2em;">
        <strong>盖章原则：</strong>
      </p>
      <p style="text-indent: 2em; ">
        项目在某一个社区、村实施，可由所在社区居委会、村委会盖章，也可由所在街道办事处、镇政府盖章；
      </p>
      <p style="text-indent: 2em; ">
        项目在某一个街道、乡镇实施，则由所在街道办事处、镇政府盖章；
      </p>
      <p style="text-indent: 2em; ">
        项目在多个社区、村实施，可由多个所在社区居委会、村委会盖章，也可由所在街道办事处、镇政府盖章；
      </p>
      <p style="text-indent: 2em; ">
        项目在多个街道、乡镇实施，可由多个所在街道办事处、镇政府盖章，也可由区级有关委办局盖章；
      </p>
      <p style="text-indent: 2em; ">
        项目在某个特定地点实施，如学校、医院、园区等，可由所在学校、医院、园区管委会等单位盖章。
      </p>
      <p style="text-indent: 2em; ">
        <strong>特殊情况：</strong>
      </p>
      <p style="text-indent: 2em; ">
        项目在全市实施，如针对全市某一特定群体开展服务项目，无明确实施地，可在申报书中将情况进行备注说明后，实施地一栏无需盖章。
      </p>
    </div>

  </el-dialog>
</template>

<script>

export default {
  name: "Dialog",
  props: {
    dialogVisibleProblem: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {

    }
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit('watchState', false)
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">

</style>
